module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightSemiCnIt.3d73d7d.ttf";